import {FilterConfiguration, FilterTypes} from '@ey/canvascoreservices';
import {labels} from '../../../../../../../util/utils';
import {SampleItemFilterConfiguration} from '../../../../../CommonConfig/Config';
import { sampleItemFilterKeys } from '../../../../../../../util/uiconstants';
import {getFilterEntities} from '../../../../../../../actions/SampleItemFilter/filteractions';

export default function getFilterConfig(filterKey, engagementId, dispatchAction) {
	const getFilterEntity = (filterItemName, entityType, entityFilter) => {
		let _entityFilter = {...entityFilter};

		// Get entity filter function, if any
		let __entityFilter = SampleItemFilterConfiguration[entityType]?.entityFilter;
		if (__entityFilter) {
			_entityFilter = __entityFilter(_entityFilter);
		}

		return dispatchAction(getFilterEntities(filterKey, filterItemName, entityType, _entityFilter));
	};

	const entityFilter = {
		engagementId: engagementId
	};

	const sampleItemFilterConfig = new FilterConfiguration(filterKey, {
		tags: {
			name: sampleItemFilterKeys.sampleItemListKey,
			label: labels.sampleItemFilterLabels.filterTypeOfTags,
			type: FilterTypes.search,
			noResultsPlaceholder: labels.sampleItemFilterLabels.noResults,
			searchPlaceholder: labels.placeholderForSearch,
			entityType: 'tags',
			data: () => getFilterEntity('tags', 'tags', entityFilter),
            dataGroupBy: (item) => item.group,
			dataMapping: SampleItemFilterConfiguration.tags.entityMapping,
			entityFilter: SampleItemFilterConfiguration.tags.entityFilter(entityFilter),
			getDisplayValue: SampleItemFilterConfiguration.tags.getDisplayValue,
			filterOrder: 1
		}
	});

	return {
		sampleItemFilterConfig,
	};
}
